export default function AboutSection() {
  return (
    <section id="about" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-teal-600 text-xs font-bold tracking-[0.3em] uppercase block mb-4">Who We Are</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A0F1C] leading-tight mb-6">
            A Team of iOS Experts<br />
            <span className="text-teal-500">Passionate About Quality</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            LINIJE d.o.o. is a Slovenian software company dedicated to crafting top-tier iOS applications
            that prioritize user security, privacy, and performance.
          </p>
        </div>

        {/* Split layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-[440px] rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/db55e7cd31409a1f7484751ca43d95b9.jpg"
                alt="LINIJE d.o.o. team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating card removed */}
          </div>

          {/* Text */}
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-[#0A0F1C] mb-5 leading-snug">
              Building iOS Apps That Make a Real Difference
            </h3>
            <p className="text-gray-500 leading-relaxed mb-5">
              Our team of expert developers and designers is united by one goal: delivering iOS applications
              that truly enhance the lives of our users. We combine deep technical knowledge with a
              human-centered design approach to create products that are both powerful and intuitive.
            </p>
            <p className="text-gray-500 leading-relaxed mb-8">
              From secure VPN tunneling technology to intelligent on-device cleaning algorithms, every feature
              we build is crafted with precision and rigorously tested to meet the highest standards of the
              Apple ecosystem.
            </p>
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: "ri-shield-check-line", label: "Security First" },
                { icon: "ri-smartphone-line", label: "iOS Native" },
                { icon: "ri-heart-pulse-line", label: "User-Centric" },
                { icon: "ri-lightbulb-line", label: "Innovation" },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-3 bg-teal-50 rounded-xl px-4 py-3">
                  <div className="w-8 h-8 flex items-center justify-center text-teal-600">
                    <i className={`${item.icon} text-xl`} />
                  </div>
                  <span className="text-[#0A0F1C] font-semibold text-sm">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Timeline removed */}
      </div>
    </section>
  );
}
